



































































import { api } from '@/services/api';
import Recaptcha from '@/components/Captchas/Recaptcha.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'ForgotView',

    components: {
        Recaptcha,
    },
    // asyncData({ store }) {
    //    store.commit('setPageMeta', {
    //        title: 'Retrieve Forgotten Login Details',
    //        headerTitle: 'Forgot',
    //    });
    //    return Promise.resolve();
    // },
    data() {
        return {
            forgotForm: {
                loading: false,
                success: false,
                error: '',

                email: '',
                recaptchaResponse: null,
            },
        };
    },
    methods: {
        executeRecaptcha(data: any, hashKey: string) {
            console.log('Execute Recaptcha', this.$refs.recaptcha);
            return this.$refs.recaptcha ? this.$refs.recaptcha.execute(data, hashKey) : null;
        },

        resetRecaptcha() {
            return this.$refs.recaptcha ? this.$refs.recaptcha.reset() : null;
        },

        submit() {
            if (this.forgotForm.loading) {
                return;
            }
            this.forgotForm.loading = true;
            this.executeRecaptcha({ email: this.forgotForm.email }, 'email');
        },

        onRecaptchaResponse(response: any) {
            this.forgotForm.recaptchaResponse = response;
            this.submitReal();
        },

        submitReal() {
            this.forgotForm.loading = true;
            this.forgotForm.error = '';
            api
                .post(
                    'forgot-password',
                    {
                        email: this.forgotForm.email,
                        recaptcha: this.forgotForm.recaptchaResponse,
                    },
                )
                .then((response) => {
                    this.forgotForm.success = response.success;
                })
                .catch(({ message }) => {
                    this.forgotForm.error = message;
                })
                .finally(() => {
                    this.forgotForm.loading = false;
                    this.resetRecaptcha();
                });
        },
    },
});
